import * as React from "react";
import type { SVGProps } from "react";
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M3.25 7.75A3.75 3.75 0 0 1 7 4h2.763a3.75 3.75 0 0 1 2.847 1.31l1.235 1.44h-1.976l-.398-.464A2.25 2.25 0 0 0 9.763 5.5H7a2.25 2.25 0 0 0-2.25 2.25v6A2.25 2.25 0 0 0 7 16h1v1.5H7a3.75 3.75 0 0 1-3.75-3.75z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 8a3.75 3.75 0 0 0-3.75 3.75v6A3.75 3.75 0 0 0 13 21.5h4a3.75 3.75 0 0 0 3.75-3.75v-4.557c0-.895-.32-1.76-.903-2.44L18.61 9.31A3.75 3.75 0 0 0 15.763 8zm-2.25 3.75A2.25 2.25 0 0 1 13 9.5h2.763c.657 0 1.28.287 1.708.786l1.237 1.443c.35.408.542.927.542 1.464v4.557A2.25 2.25 0 0 1 17 20h-4a2.25 2.25 0 0 1-2.25-2.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCopy;
